export type LanguageCode = 'pt-BR' | 'en-US';

export interface Language {
  code: LanguageCode;
  name: string;
  flag: string;
}

export const availableLanguages: Language[] = [
  {
    code: 'pt-BR',
    name: 'Português (Brasil)',
    flag: '🇧🇷'
  },
  {
    code: 'en-US',
    name: 'English (US)',
    flag: '🇺🇸'
  }
];
